import { ReactNode, useState } from 'react'
import { ConfirmRollbackDialog } from '../Tasks/ConfirmRollbackDialog'
import { RollbackContext } from './RollbackContext'

type RollbackProviderProps = {
  children: ReactNode
  engagementId?: string
  taskStatus: any
}

type RollbackState = {
  open: boolean
  rollbackTaskIds?: string[]
  onSuccess?: () => void
}

export const RollbackProvider = ({ children, engagementId, taskStatus }: RollbackProviderProps) => {
  const canRollback =
    !taskStatus?.allowedActions?.includes('canModify') &&
    !!taskStatus?.allowedActions?.includes('unconfirmToModify')

  const [confirmRollbackState, setConfirmRollbackState] = useState<RollbackState>({
    open: false,
    rollbackTaskIds: [],
  })
  const closeRollbackDialog = () => setConfirmRollbackState({ open: false })

  const openRollbackForTask = (state?: Partial<RollbackState>) => {
    setConfirmRollbackState({
      open: true,
      rollbackTaskIds: taskStatus?.preventsModification?.confirmations,
      ...state,
    })
  }

  return (
    <RollbackContext.Provider value={{ canRollback, openRollbackForTask }}>
      {children}

      <ConfirmRollbackDialog
        engagementId={engagementId}
        {...confirmRollbackState}
        onClose={closeRollbackDialog}
      />
    </RollbackContext.Provider>
  )
}
